type OrganizationNumberFormatter = {
    /** Number of digits the formatter expects. Other lengths are shown as-is. */
    digits: number;
    format: (digits: string) => string;
};

const formatters: Record<string, OrganizationNumberFormatter> = {
    SE: { digits: 10, format: d => `${d.slice(0, 6)}-${d.slice(6)}` },
    NO: { digits: 9, format: d => `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}` },
    FI: { digits: 8, format: d => `${d.slice(0, 7)}-${d.slice(7)}` },
    DK: {
        digits: 8,
        format: d => `${d.slice(0, 2)} ${d.slice(2, 4)} ${d.slice(4, 6)} ${d.slice(6)}`,
    },
};

/** Strips separators so organization numbers can be compared regardless of formatting. */
export const normalizeOrganizationNumber = (organizationNumber: string | undefined): string =>
    (organizationNumber ?? '').replace(/[\s-]/g, '').toLowerCase();

/**
 * Formats an organization number for display per country (SE 556123-4567, NO 123 456 789,
 * FI 1234567-8, DK 12 34 56 78). Unknown countries or unexpected lengths are returned untouched.
 */
export const formatOrganizationNumber = (
    countryCode: string | undefined,
    organizationNumber: string | undefined
): string => {
    const value = (organizationNumber ?? '').trim();
    const formatter = formatters[(countryCode ?? '').toUpperCase()];

    if (!formatter) return value;

    const digits = value.replace(/\D/g, '');

    return digits.length === formatter.digits && /^[\d\s-]+$/.test(value)
        ? formatter.format(digits)
        : value;
};
